import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = [
    "modalContainer"
  ]

  hide() {
    this.modalContainerTarget.remove()
  }

  submitEnd(e) {
    if (e.detail.success && !e.target.dataset.modalKeepOpen) {
      this.hide()
    }
  }

  closeWithKey(e) {
    if (e.code == "Escape") {
      this.hide()
    }
  }

  closeBackground(e) {
    if (e && this.modalContainerTarget.contains(e.target.parentElement)) {
      return
    }
    this.hide()
  }
}
